import React from 'react'
import { Controller, FieldValues } from 'react-hook-form'
import { Checkbox, CheckboxProps } from './Checkbox'
import { RhfProps } from '../RhfProps'

type CheckboxRhfProps<T extends FieldValues> = CheckboxProps & RhfProps<T>

export function CheckboxRhf<T extends FieldValues>({
  name,
  rules = {},
  control,
  defaultValue,
  ...inputProps
}: CheckboxRhfProps<T>) {
  if (inputProps.required) {
    rules.required = 'This field is required'
  }
  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      defaultValue={defaultValue}
      render={({ field: { onChange, value }, fieldState: { error } }) => (
        <Checkbox
          {...inputProps}
          value={value ?? false}
          error={!!error}
          onChange={onChange}
          helperText={error ? error.message : inputProps.helperText}
        />
      )}
    />
  )
}
